import React from "react";
import { animated, useTransition } from "@react-spring/web";
import Button from "src/components/button";
import styles from "./saveConfirmation.module.scss";

interface SaveConfirmationProps {
  show: boolean;
  isSaving: boolean;
  message: string;
  onSave: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
  loadingText?: string;
}

const SaveConfirmation: React.FC<SaveConfirmationProps> = ({
  show,
  isSaving,
  message,
  onSave,
  onCancel,
  confirmText = "Save",
  cancelText = "Reset",
  loadingText = "Saving...",
}) => {
  const transitions = useTransition(show, {
    initial: { opacity: 0, top: "0px" },
    from: { opacity: 1, top: "-90px" },
    enter: { opacity: 1, top: "0px" },
    leave: { opacity: 0, top: "-90px" },
  });

  return transitions(
    (style, item) =>
      item && (
        <animated.div style={style} className={styles.saveConfirmation}>
          <div className={styles.message}>{message}</div>
          <Button
            variant="primary"
            icon="paperflite-tick"
            disabled={isSaving}
            text={isSaving ? loadingText : confirmText}
            onClick={onSave}
          />
          <Button
            variant="secondary"
            text={cancelText}
            disabled={isSaving}
            onClick={onCancel}
          />
        </animated.div>
      ),
  );
};

export default SaveConfirmation;